// src/services/module/ModuleService.ts

import { moduleApi } from "../../api";

const ModuleService = {
  /**
   * 🔹 Obtener la lista de módulos (información básica).
   */
  getModules: async () => {
    const response = await moduleApi.fetchAll();
    return response.data;
  },

  /**
   * 🔹 Obtener el detalle completo de un módulo
   */
  getModuleDetail: async (moduleId: number) => {
    const response = await moduleApi.fetchCustom(`/${moduleId}/detail`);
    return response.data;
  },

  /**
   * 🔹 Cambiar el nombre de un módulo
   */
  updateModuleName: async (payload: object) => {
    const response = await moduleApi.modifyCustom("/name", payload);
    return response.data;
  },

  /**
   * 🔹 Cambiar la categoría de un módulo
   */
  updateModuleCategory: async (payload: object) => {
    const response = await moduleApi.modifyCustom("/category", payload);
    return response.data;
  },

  /**
   * 🔹 Cambiar el orden de un módulo
   */
  updateModuleOrder: async (payload: object) => {
    const response = await moduleApi.modifyCustom("/order", payload);
    return response.data;
  },

  /**
   * 🔹 Cambiar los roles asociados a un módulo
   */
  updateModuleRoles: async (payload: object) => {
    const response = await moduleApi.modifyCustom("/roles", payload);
    return response.data;
  },

  /**
   * 🔹 Cambiar el icono de un módulo
   */
  updateModuleIcon: async (payload: object) => {
    const response = await moduleApi.modifyCustom("/icon", payload);
    return response.data;
  },

  /**
   * 🔹 Cambiar la ruta asociada al módulo
   */
  updateModuleRoute: async (payload: object) => {
    const response = await moduleApi.modifyCustom("/route", payload);
    return response.data;
  },

  /**
   * 🔹 Activar o desactivar un módulo
   */
  toggleModuleStatus: async (payload: object) => {
    const response = await moduleApi.modifyCustom("/status", payload);
    return response.data;
  },

  /**
   * 🔹 Cambiar propiedad hasChildren
   */
  updateModuleHasChildren: async (payload: object) => {
    const response = await moduleApi.modifyCustom("/children", payload);
    return response.data;
  },
};

export default ModuleService;
